import React from "react";
import { Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import BPADocumentsPreview from "../ApplicationDetails/components/BPADocumentsPreview";
import { getOrderDocuments } from "@egovernments/digit-ui-module-obps/src/utils";
import NOCCheckList from "./NOCChecklist";

const NOCFormatView = ({ formData, applicationDocs }) => {
    const { t } = useTranslation()
    const isUdFlow = formData?.applicationNo?.includes('UD')
    const landAreaDetails = formData?.landAreaDetails
    const professionalDetails = formData?.professionalInformation
    const tcpNOCDetails = formData?.tcpNOCdetails
    const udNOCDetails = formData?.udNOCdetails
    const checklist = formData?.checklist
    const feeDetails = formData?.taxHeadEstimate?.[0]
    const udNOCdetailsDocuments = applicationDocs?.filter(doc => doc?.documentType?.includes('udNOCdetails'));
    const stabilityDocDocuments = applicationDocs?.filter(doc => doc?.documentType === 'stabilityDoc');
    return (
        <React.Fragment>
            <div style={{
                marginTop: "1px",
                backgroundColor: "#fff",
            }}>
                <div style={{
                    textAlign: "center", marginBottom: "5px",
                    backgroundColor: "#99b3d98c",
                    border: "1px solid rgba(91, 90, 95, 0.35)"
                }}><b>NOC Application</b></div>
                <Card style={{ backgroundColor: "#eeeab5b0", padding: "20px" }}>
                    NOC Form used for taking permission for Electrical, Sewerage, and water connection from the Urban Development Department.
                </Card>
                <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                    <CardContent>
                        <div style={{
                            textAlign: "center",
                            marginBottom: "5px",
                            backgroundColor: "#99b3d98c",
                            border: "1px solid rgba(91, 90, 95, 0.35)"
                        }}>
                            <Typography variant="h6" component="h2">
                                Application Details:
                            </Typography>
                        </div>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Apllication Type: {formData?.applicationType}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Applied For: {formData?.appliedFor}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Reference Application No: {formData?.oldApplicationNo}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Application No: {formData?.applicationNo}
                                </Typography>
                            </Grid>
                            {/* Row 1 */}
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    District: {landAreaDetails?.city}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Notified-Area: {landAreaDetails?.locality?.name}
                                </Typography>
                            </Grid>

                            {/* Row 2 */}
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Village: {landAreaDetails?.village?.name}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Area Type: {landAreaDetails?.areaType}
                                </Typography>
                            </Grid>

                            {/* Row 3 */}

                        </Grid>
                    </CardContent>
                </Card>
                <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                    <CardContent>
                        <div style={{
                            textAlign: "center",
                            marginBottom: "5px",
                            backgroundColor: "#99b3d98c",
                            border: "1px solid rgba(91, 90, 95, 0.35)"
                        }}>
                            <Typography variant="h6" component="h2">
                                Professional Details:
                            </Typography>
                        </div>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Name: {professionalDetails?.name}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Registration Number: {professionalDetails?.registrationNumber}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Mobile Number: {professionalDetails?.mobileNumber}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Email-Id    : {professionalDetails?.emailId}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1">
                                    Address: {professionalDetails?.address?.address} 
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                {!isUdFlow && (
                    <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                        <CardContent>
                            <div style={{
                                textAlign: "center",
                                marginBottom: "5px",
                                backgroundColor: "#99b3d98c",
                                border: "1px solid rgba(91, 90, 95, 0.35)"
                            }}>
                                <Typography variant="h6" component="h2">
                                    NOC Details:
                                </Typography>
                            </div>
                            {tcpNOCDetails?.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <Typography variant="body1">
                                                NOC Type: {item?.nocType}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body1">
                                                Floor Type: {item?.floorName}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body1">
                                                Land-Use Type : {item?.landUseType}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="body1">
                                                Services  : {item?.services}
                                            </Typography>
                                        </Grid>
                                    </Grid>

                                    {index !== tcpNOCDetails.length - 1 && <Divider style={{marginTop: '10px'}}/>} {/* Add divider if not the last item */}
                                </React.Fragment>
                            ))}
                        </CardContent>
                    </Card>
                )}
                {isUdFlow && (
                    <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                        <CardContent>
                            <div style={{
                                textAlign: "center",
                                marginBottom: "5px",
                                backgroundColor: "#99b3d98c",
                                border: "1px solid rgba(91, 90, 95, 0.35)"
                            }}>
                                <Typography variant="h6" component="h2">
                                    NOC Details:
                                </Typography>
                            </div>
                            {udNOCDetails?.map((item, index) => (
                                <React.Fragment key={index}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="body1">
                                                Name: {item.name}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="body1">
                                                Email: {item.emailId}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="body1">
                                                Applied On: {new Date(item.appliedOnDate).toLocaleDateString()}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="body1">
                                                Categories: {item.categories}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="body1">
                                                Blocks: {item.blockNameAsPerDatabase}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="body1">
                                                Floor Name: {item.floorName}
                                            </Typography>
                                        </Grid>
                                    </Grid> <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <Typography variant="body1">
                                                No of Connections: {item.noOfConnections}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant="body1">
                                                Noc Type: {item.nocType}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div>
                                                 {<BPADocumentsPreview documents={getOrderDocuments([udNOCdetailsDocuments[index]])} svgStyles={{}} isSendBackFlow={false} isHrLine={true} titleStyles={{ fontSize: "18px", lineHeight: "24px", "fontWeight": 700, marginBottom: "10px" }} />}
                                            </div>
                                        </Grid>
                                    </Grid>
                                    {index !== udNOCDetails.length - 1 && <Divider />} {/* Add divider if not the last item */}
                                </React.Fragment>
                            ))}
                        </CardContent>
                    </Card>
                )}
                {checklist && (
                    <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                        <CardContent>
                            <div style={{
                                textAlign: "center",
                                marginBottom: "5px",
                                backgroundColor: "#99b3d98c",
                                border: "1px solid rgba(91, 90, 95, 0.35)"
                            }}>
                                <Typography variant="h6" component="h2">
                                    Checklist Details:
                                </Typography>
                            </div>
                            <NOCCheckList checklist={checklist}/>
                        </CardContent>
                    </Card>
                )}
                {isUdFlow && (
                    <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                        <CardContent>
                            <div style={{
                                textAlign: "center",
                                marginBottom: "5px",
                                backgroundColor: "#99b3d98c",
                                border: "1px solid rgba(91, 90, 95, 0.35)"
                            }}>
                                <Typography variant="h6" component="h2">
                                    Document Details:
                                </Typography>
                            </div>
                            <Grid container spacing={2}>
                                <Grid item xs={3}>
                                    <Typography variant="body1">
                                        Stability Document:
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <div>
                                        <BPADocumentsPreview documents={getOrderDocuments(stabilityDocDocuments)} svgStyles={{}} isSendBackFlow={false} isHrLine={true} titleStyles={{ fontSize: "18px", lineHeight: "24px", "fontWeight": 700, marginBottom: "10px" }} />
                                    </div>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                )}
                {isUdFlow && <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                    <CardContent>
                        <div style={{
                            textAlign: "center",
                            marginBottom: "5px",
                            backgroundColor: "#99b3d98c",
                            border: "1px solid rgba(91, 90, 95, 0.35)"
                        }}>
                            <Typography variant="h6" component="h2">
                                Fee Details
                            </Typography>
                        </div>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="body1">
                                    Total Amount: {feeDetails?.estimateAmount}
                                </Typography>
                            </Grid>

                        </Grid>
                    </CardContent>
                </Card>}
            </div>
        </React.Fragment>
    );
}
export default NOCFormatView;